import { styled } from '@mui/material/styles';

const BootstrapContainer = styled('div')(({ theme }) => ({
  width: '100%',
  paddingRight: '0.75rem',
  paddingLeft: '0.75rem',
  marginRight: 'auto',
  marginLeft: 'auto',
  '@media (min-width: 576px)': {
    maxWidth: 540,
  },
  '@media (min-width: 768px)': {
    maxWidth: 720,
  },
  '@media (min-width: 992px)': {
    maxWidth: 960,
  },
  '@media (min-width: 1200px)': {
    maxWidth: 1140,
  },
  '@media (min-width: 1400px)': {
    maxWidth: 1320,
  },
}));

export default BootstrapContainer;
